import React, {useState, useEffect} from 'react';
import {
    FormControlLabel,
    FormGroup,
    List,
    ListItem,
    MenuItem,
    Paper,
    Switch,
    TextField,
    Typography
} from "@mui/material";
import {withStyles, makeStyles} from "@mui/styles";
import {newRequestApi, isWidget, getCompany} from "../../utils/utils";
import { useHistory, useLocation } from 'react-router-dom';

const NautilusTextInput = withStyles({
    root: {
		'& .css-14lo706': {
			fontSize: '0.85em',
        },
    },
})(TextField);

let yearsAmount = 4;
const maxYear = window['availMaxYear'] ? parseInt(window['availMaxYear']) : null;

const currentYear = new Date().getFullYear();
if (maxYear) yearsAmount = (maxYear - currentYear) + 1;
if (yearsAmount < 1) yearsAmount = 1;
if (yearsAmount > 15) yearsAmount = 15;

const yearList = Array.from(Array(yearsAmount), (_, i) => (currentYear + i).toString());

const useStyles = makeStyles((theme) => ({
  listItem: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '50%',
    },
  },
}));

const SearchFilterAccordion = ({destinations, adventures, ships, setSearchForm, searchForm, setShowFilters, showFilters,history}) => {
	const [months, setMonths] = useState([
		{ id: "01", label: "January", enabled: true },
		{ id: "02", label: "February", enabled: true },
		{ id: "03", label: "March", enabled: true },
		{ id: "04", label: "April", enabled: true },
		{ id: "05", label: "May", enabled: true },
		{ id: "06", label: "June", enabled: true },
		{ id: "07", label: "July", enabled: true },
		{ id: "08", label: "August", enabled: true },
		{ id: "09", label: "September", enabled: true },
		{ id: "10", label: "October", enabled: true },
		{ id: "11", label: "November", enabled: true },
		{ id: "12", label: "December", enabled: true },
	]);
    
	const classes = useStyles();
    const [company,setCompany] = useState({});
    const historyUrl = useHistory();
    const location = useLocation();
    useEffect( async () =>{
        if (isWidget()) {
            const companyData = await getCompany();
            // Verify if the property 'company' exists inside the object companyData.
            // console.log(companyData);
            if (companyData.company && companyData.company !== '') {
                setCompany(companyData);
            }
        }
    },[]);
    useEffect(() => {
        if (!searchForm.destination) {
            let newMonthList = _.cloneDeep(months);
            newMonthList.map(m => m.enabled = true);
            setMonths(newMonthList);
            return;
        }

        disableUnavailableData().catch();
    }, [searchForm.months, searchForm.year, searchForm.onlyDealerTrips]);

    const disableUnavailableData = async (preloader = false) => {
        const params = { tripClass: searchForm.destination};
        if (searchForm.year) params['year'] = searchForm.year;
        const {data} = await newRequestApi('/get-months-by-trip-class', 'POST', params, null, preloader);
        if (data.status !== 'success') return;
        const availableMonths = data.data || [];
        const idList = availableMonths.flatMap(x => x.id);

        // Check if there was a selected month and remove it if disabled
        checkMonthSelection(idList);

        let newMonthList = _.cloneDeep(months);
        newMonthList.map(m => m.enabled = idList.includes(m.id));
        setMonths(newMonthList);
    }

    const checkMonthSelection = (monthArray = []) => {
        if (!searchForm.month) return;

        if (!monthArray.includes(searchForm.month)) setSearchForm({...searchForm, 'month': ''});
    };
	
    // Function to update the URL with the filters
    const updateUrlWithFilters = (newFilters) => {
        const searchParams = new URLSearchParams(location.search);
        
        // Update or delete parameters according to the filter values
        Object.entries(newFilters).forEach(([key, value]) => {
            if (key === 'hideUnavailable') {
                if (value === false) {
                    searchParams.set(key, value);
                } else {
                    searchParams.delete(key);
                }
            } else if (value) {
                searchParams.set(key, value);
            } else {
                searchParams.delete(key);
            }
        });
        historyUrl.push({
            pathname:"",
            search: searchParams.toString()
        });
    };

    const handleForm = (event) => {
        const newSearchForm = {...searchForm, [event.target.name]: event.target.value};
        setSearchForm(newSearchForm);
        updateUrlWithFilters({ [event.target.name]: event.target.value });
    };

    const handleMainDestination = (id) => {
        const newSearchForm = {...searchForm, destinationId: id, destination: ''};
        setSearchForm(newSearchForm);
        updateUrlWithFilters({ 
            destinationId: id,
            destination: ''
        });
    };

    const handleSubDestination = (subId) => {
        const newSearchForm = {...searchForm, destination: subId, destinationId: ''};
        setSearchForm(newSearchForm);
        updateUrlWithFilters({ 
            destination: subId, 
            destinationId: '' 
        });
    };

    const handleCheckbox = (event) => {
        const newSearchForm = {...searchForm, hideUnavailable: event.target.checked};
        setSearchForm(newSearchForm);
        updateUrlWithFilters({ hideUnavailable: event.target.checked });
    };

    const showHideFilters = (event) =>{
        setShowFilters(event.target.checked);
    };

    const showOnlyDealerTrips = (event) => {
        const newSearchForm = {...searchForm, [event.target.name]: event.target.checked};
        setSearchForm(newSearchForm);
        updateUrlWithFilters({ [event.target.name]: event.target.checked });
    };

    const groupedAdventures = adventures.reduce((groups, adventure) => {
        const brand = adventure.brand || 'No Brand';
        if (!groups[brand]) {
            groups[brand] = [];
        }
        groups[brand].push(adventure);
        return groups;
    }, {});
    const menuItems = [];

    Object.keys(groupedAdventures).forEach((brand, brandIndex) => {
        if (brand !== 'No Brand') {
            menuItems.push(
                <MenuItem key={`brand-${brandIndex}`} disabled sx={{ fontWeight: 'bold', opacity: '1 !important' }}>
                    {brand}
                </MenuItem>
            );
        }

        groupedAdventures[brand].forEach((adventure, adventureIndex) => {
            menuItems.push(
                <MenuItem
                    key={`adventure-${brandIndex}-${adventureIndex}`}
                    value={adventure.name.replace(/\s+/g, '-').toLowerCase()}
                    sx={{ paddingLeft: brand !== 'No Brand' ? '30px' : '16px' }}
                >
                    {adventure.name}
                </MenuItem>
            );
        });
    });


    return (
        <Paper elevation={3} style={{position: 'sticky', top: '20px', bottom: '50px'}}>
            <List style={{width: '100%', paddingBottom: 0, paddingTop: 0, display: 'flex', flexWrap: 'wrap'}} className={'searchFilterForm'}>
                <ListItem sx={{backgroundColor: '#333'}}>
                    <Typography variant="h3" align="center" sx={{
                        fontSize: '2rem',
                        color: '#fff',
                        fontWeight: 500,
                        padding: '10px',
                        paddingLeft: '20px'
                    }}>
                        Find the perfect Adventure!
                    </Typography>
                </ListItem>
                <ListItem style={{marginTop: '10px'}} className={isWidget() ? classes.listItem : ''}>
                    <NautilusTextInput id="destinationSelect" label="Destination" fullWidth name="destination"
                               value={searchForm['destinationId'] ? `main-${searchForm['destinationId']}` : searchForm['destination']} variant="outlined" select>
                        <MenuItem value="" onClick={()=>handleSubDestination('')}>I want to see</MenuItem>
                        {destinations.map(d =>
                                d['destinations'].length > 0 && [
                                <MenuItem key={d['id']} sx={{fontWeight:'bold'}} value={`main-${d['id']}`} onClick={()=>handleMainDestination(d['id'])}>
                                    {d['name']}
                                </MenuItem>,
                                    d['destinations'].map(dd => (
                                        <MenuItem sx={{paddingLeft:'30px'}} key={dd.tripClassId} value={dd['tripClassId']} onClick={()=>handleSubDestination(dd['tripClassId'])}>
                                            {dd.class}
                                        </MenuItem>
                                    ))
                                ]
                        )}
                    </NautilusTextInput>
                </ListItem>
                <ListItem className={isWidget() ? classes.listItem : ''}>
                    <NautilusTextInput
                        id="adventureSelect"
                        label="Adventure"
                        fullWidth
                        name="adventure"
                        value={searchForm['adventure']}
                        onChange={handleForm}
                        variant="outlined"
                        select
                    >
                        <MenuItem value={''}>All adventures</MenuItem>
                        {menuItems}
                    </NautilusTextInput>
                </ListItem>
                {!isWidget() &&
                <ListItem>
                    <NautilusTextInput id="shipSelect" label="Ship Or Camp" fullWidth name="location"
                               value={searchForm['location']} onChange={handleForm} variant="outlined" select>
						<MenuItem value={''}>All ships or camps</MenuItem>
                        {ships.map(s => <MenuItem key={s.id} value={s.id}>{s.value}</MenuItem>)}
                    </NautilusTextInput>
                </ListItem>
				}
                <ListItem className={isWidget() ? classes.listItem : ''}>
                    <NautilusTextInput id="yearSelect" label="Year" fullWidth name="year" value={searchForm['year']}
                               onChange={handleForm} variant="outlined" select>
                        <MenuItem value="">All Years</MenuItem>
                        {yearList.map(year => <MenuItem value={year} key={year}>{year}</MenuItem>)}
                    </NautilusTextInput>
                </ListItem>
                <ListItem className={isWidget() ? classes.listItem : ''}>
                    <NautilusTextInput id="monthSelect" label="Month" fullWidth name="month" value={searchForm['month']}
                               onChange={handleForm} variant="outlined" select>
                        <MenuItem value="">All Months</MenuItem>
                        {months.map(m => (
                            <MenuItem key={m.id} value={m.id} disabled={!m.enabled}>{m.label}</MenuItem>
                        ))}
                    </NautilusTextInput>
                </ListItem>
				{!isWidget() &&
                <ListItem>
                    <NautilusTextInput id="spaceSelect" label="Spaces Available" fullWidth name="space"
                               value={searchForm['space']} onChange={handleForm} variant="outlined" select>
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="1">1 or more spaces</MenuItem>
                        <MenuItem value="2">2+</MenuItem>
                        <MenuItem value="5">5+</MenuItem>
                        <MenuItem value="10">10+</MenuItem>
                        <MenuItem value="15">15+</MenuItem>
                    </NautilusTextInput>
                </ListItem>
				}
                <ListItem>
                    <FormGroup style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <FormControlLabel
                            control={
								<Switch
									size={'small'}
                                    color={'primary'}
                                    checked={searchForm['hideUnavailable']}
                                    value={searchForm['hideUnavailable']}
                                    name="hideUnavailable"
                                    onChange={handleCheckbox}
								/>
								}
                            label=""
                        />
                        <span style={{fontSize: '1.2rem'}}>Show only trips with availability</span>
                    </FormGroup>
                    {isWidget() && Object.keys(company).length>0 && <FormGroup style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <FormControlLabel
                            control={
                                <Switch
                                    size={'small'}
                                    color={'primary'}
                                    checked={searchForm['onlyDealerTrips']}
                                    value={searchForm['onlyDealerTrips']}
                                    name="onlyDealerTrips"
                                    onChange={showOnlyDealerTrips}
                                />
                            }
                            label=""
                        />
                        <span style={{fontSize: '1.2rem'}}>Show {company.company} Trips Only</span>
                    </FormGroup>}
                </ListItem>

            </List>
        </Paper>
    );
};

export default SearchFilterAccordion;